import React, { useEffect } from "react"
import { LotteryState } from "../../config/types"
import Avatar3D from "../../views/ranking3D"
import { page } from "../../pages/ranking3D"
import { defPath } from "../../config/defPath"
interface PorpsLotteryConfirm {
    data: LotteryState["confirm"]
    code: string[]
}

export const LotterySuccess: React.FC<PorpsLotteryConfirm> = ({ data, code }) => {

    useEffect(() => {
        window.dataLayer && window.dataLayer.push({
            "event": "GAEvent",
            "event_category": "Content",
            "event_action": "Content",
            "event_label": "Successful Prediction",
            "interaction": "true",
            "component_name": "Modo_Carrera_TriviaLottery",
            "element_text": "Ya hiciste tu predicción",
        });

        window.matchMedia("(min-width: 991px)").matches && page()
    }, [])

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()
        const link = event.currentTarget.href

        window.dataLayer && window.dataLayer.push({
            "event": "GAEvent",
            "event_category": "Content",
            "event_action": "Button",
            "event_label": "Successful Prediction - Return stadium",
            "interaction": "true",
            "component_name": "Modo_Carrera_TriviaLottery",
            "element_text": "Ir al estadio",
        });

        link && (window.location.href = link)
    }

    const size = data.title.value.length

    return (
        <div className="lotteryConfirm">
            <div className="lotteryConfirm__content">
                <h1 className={`lotteryConfirm__content--title ${size > 20 ? "text-large" : ""}`} dangerouslySetInnerHTML={{ __html: data.title.value }}></h1>
                <div className="lotteryConfirm__content--subtitle" dangerouslySetInnerHTML={{ __html: data.copy1.value }}></div>
                
                {
                    code.length > 0 && (
                        <section className="lotteryConfirm__content--numbers">
                            {
                                code.length && code.map((item, index) => (
                                    <span key={`${item}_${index}`}>{item}</span>
                                ))
                            }
                        </section>
                    )
                }

                <a className="lotteryConfirm__content--btn" href={data.url1} onClick={handleClick} dangerouslySetInnerHTML={{ __html: data.btn1 }}></a>
            </div>

            {window.matchMedia("(min-width: 991px)").matches &&
                (<div className={`lotteryConfirm--canvas`}>
                    <Avatar3D />
                </div>)
            }
        </div>
    )
}